import { GenericObject } from "@mongez/reinforcements";
import { Filter } from "core/catalog";
import { cn } from "core/shared";
import { CheckboxInput } from "~/design-system/components";
import { getLocalizedValue } from "~/shared/urils/getLocalizedValue";
import { useSelectFilter } from "../../hooks";

type SelectFilterProps = {
  filter: Filter;
};

export function SelectFilter({ filter }: SelectFilterProps) {
  const { currentActiveFilters, handleCheckboxChange, sortedData } =
    useSelectFilter(filter);

  const isChecked = (id: string) => currentActiveFilters.includes(String(id));

  return (
    <>
      {sortedData.map((item: GenericObject) => {
        // Each entry wraps its own record (category / brand / option) and the
        // name is localized, so it may come back as a localized array.
        const record = item.category || item.brand || item.option;
        const name = String(
          getLocalizedValue(record?.name) || item.text || "",
        );
        const id = record?.id ?? item.id;

        if (!id) return null;

        return (
          <div
            key={`${id}-${name}`}
            className="flex items-center justify-between"
          >
            <CheckboxInput
              id={id}
              defaultChecked={currentActiveFilters.includes(String(id))}
              label={name}
              name="select-filter"
              classes={{
                label: "!capitalize",
                input: cn("rounded-md"),
              }}
              onChange={(isChecked) => {
                handleCheckboxChange(id, isChecked);
              }}
              defaultValue={isChecked(id)}
            />
            <span className="text-smoky-black font-medium">{item.total}</span>
          </div>
        );
      })}
    </>
  );
}
